export default {"src":"/_next/static/media/Icon3.a91e45f8.svg","height":51,"width":50};